import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'How does editing photos and videos using simple instructions work?',
    a: 'Instead of manually adjusting complex color wheels, curves, or cutlines, you simply type plain language instructions into PFP AI. For example, typing "add dynamic cyber glow accents" or "restore old faded background" instructs our deep AI core to instantly render the output precisely as described.',
  },
  {
    q: 'Can I generate completely new images from scratch?',
    a: 'Yes! PFP AI includes a highly advanced text-to-image engine. Just describe the character, art style, or cinematic landscape you envision, and our app generates master-quality digital artwork instantly.',
  },
  {
    q: 'Does instruction-based editing support video filters and effects?',
    a: 'Absolutely. You can specify atmospheric effects or apply persistent stylistic video themes across entire sequences natively. No manual frame-by-frame adjustments required.',
  },
  {
    q: 'Is PFP AI available for download immediately?',
    a: 'Yes, PFP AI Studio is fully released and optimized for instant installation on the Google Play Store.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-20 px-6 max-w-4xl mx-auto">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-[#161B26] border border-gray-800 px-4 py-1.5 rounded-full text-sm font-semibold text-[#E63946] mb-4">
          <HelpCircle className="w-4 h-4" /> Got Questions?
        </div>
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
          Frequently Asked <span className="text-[#E63946]">Questions</span>
        </h2>
        <p className="text-gray-400 mt-4 text-base md:text-lg">
          Everything you need to know about revolutionizing your creative workflow.
        </p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, i) => {
          const isOpen = openIdx === i;
          return (
            <div
              key={i}
              className={`border rounded-2xl transition-all duration-300 overflow-hidden ${
                isOpen ? 'bg-[#121622] border-[#E63946]/40' : 'bg-[#0E121E] border-gray-800/80 hover:border-gray-700'
              }`}
            >
              <button
                onClick={() => setOpenIdx(isOpen ? -1 : i)}
                className="w-full text-left p-6 flex justify-between items-center gap-4 focus:outline-none"
              >
                <span className={`font-bold text-base md:text-lg transition-colors ${isOpen ? 'text-[#E63946]' : 'text-white'}`}>
                  {faq.q}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-gray-400 shrink-0 transition-transform duration-300 ${
                    isOpen ? 'rotate-180 text-[#E63946]' : ''
                  }`}
                />
              </button>

              <div className={`transition-all duration-300 px-6 pb-6 text-gray-300 leading-relaxed ${isOpen ? 'block' : 'hidden'}`}>
                <div className="pt-2 border-t border-gray-800/60 text-sm md:text-base">
                  {faq.a}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
